export default __webpack_public_path__ + "static/media/9.bda43a52.wav";